import type { IUpsRatingLambdaRequest, IUpsRatingResponse } from "@/types/order";
import type { ICreateDraftOrder, IPaymentParam } from "@repo/shopify/api/createDraftOrder";

/**
 * 동남아 간편 결제 - 결제 취소
 */
export const fetchCancelPayment = async (param: { paymentKey: string; orderId: string; amount: string }) => {
  try {
    // tint_payment_cancel_intl
    const url = "https://hk4xwi6uu727neh3vuaecopspa0iniqn.lambda-url.ap-northeast-2.on.aws/";

    // fetchCancelPayment가 정상적으로 호출됐는지 확인하기 위해 로그 출력
    console.log("[THISISNEVERTHAT INTL] Cancel payment request");

    const response = await fetch(url, { method: "POST", body: JSON.stringify(param) }).then((res) => res);
    if (response.status === 200) {
      return (await response.json()) as ICreateDraftOrder;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

/**
 * 동남아 간편 결제 - 주문 생성
 */
export const createDraftOrderAsia = async (
  param?: IPaymentParam & { paymentKey: string; orderId: string; amount: number },
) => {
  try {
    // tint_order_process_asia_intl
    const url = "https://q6hh2utj2zacebct22tt6ugtma0shfkj.lambda-url.ap-northeast-2.on.aws/";
    const response = await fetch(url, { method: "POST", body: JSON.stringify(param) }).then((res) => res);
    const data = (await response.json()) as ICreateDraftOrder;
    return { status: response.status, data };
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

/**
 * One Time Payment
 */
export const fetchOneTimePayment = async (param: {
  storeName: string;
  paymentMethod: string;
  amount: string;
  paymentKey: string;
  metaobjectId: string;
  metaobjectHandle: string;
}) => {
  try {
    const url = "https://hmavc276gmui63wiku2c2aabfu0xjgml.lambda-url.ap-northeast-2.on.aws/";
    const response = await fetch(url, { method: "POST", body: JSON.stringify(param) }).then((res) => res);
    if (response.status === 200) {
      return { message: "success" };
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

/**
 * UPS Rating 람다 호출 - 배송비 조회
 */
export const getUpsRating = async (param: IUpsRatingLambdaRequest): Promise<IUpsRatingResponse> => {
  try {
    const url = "https://4am26q4yz3yyhftnbgqwb6i34u0dsosi.lambda-url.ap-northeast-2.on.aws/";
    const response = await fetch(url, { method: "POST", body: JSON.stringify(param) });
    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(`HTTP ${response.status}: ${errorBody}`);
    }
    return (await response.json()) as IUpsRatingResponse;
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

/**
 * customer 정보 업데이트
 * lambda: thisisneverthat_customer_update
 */
export const fetchUpdateCustomer = async (param: {
  domain: string;
  gender: string;
  height: string;
  weight: string;
  customerId: string;
}): Promise<boolean> => {
  try {
    const url = "https://unialr2jakj375arzbiqesc3sy0qqqkx.lambda-url.ap-northeast-2.on.aws/";
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(param),
    }).then((res) => res);

    if (response.status === 200) {
      return true;
    }

    return false;
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
